// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientConsents_root__RexlL","consentsList":"PatientConsents_consentsList__3mx_d","consentsListEmpty":"PatientConsents_consentsListEmpty__1ECPO"};